import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, ExternalLink } from 'lucide-react';
import { APP_VERSION, APP_SHA, APP_BUILT_AT, APP_BRANCH } from '../../version';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">
              Monness, Crespi, Hardt & Co., Inc.
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Commission tracking and management system for trading operations.
            </p>
            <div className="flex items-center space-x-4 text-sm text-gray-600">
              <div className="flex items-center">
                <Phone className="h-4 w-4 mr-2" />
                <span>Contact Support</span>
              </div>
              <div className="flex items-center">
                <Mail className="h-4 w-4 mr-2" />
                <span>System Admin</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-sm text-gray-600 hover:text-primary-600">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/csv-upload" className="text-sm text-gray-600 hover:text-primary-600">
                  CSV Upload
                </Link>
              </li>
              <li>
                <Link to="/transactions" className="text-sm text-gray-600 hover:text-primary-600">
                  Transactions
                </Link>
              </li>
              <li>
                <Link to="/reports/commission" className="text-sm text-gray-600 hover:text-primary-600">
                  Commission Reports
                </Link>
              </li>
            </ul>
          </div>

          {/* Account Links */}
          <div>
            <h4 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">
              My Account
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/profile" className="text-sm text-gray-600 hover:text-primary-600">
                  My Profile
                </Link>
              </li>
              <li>
                <Link to="/change-password" className="text-sm text-gray-600 hover:text-primary-600">
                  Change Password
                </Link>
              </li>
              <li>
                <Link to="/accounts" className="text-sm text-gray-600 hover:text-primary-600">
                  Account Management
                </Link>
              </li>
              <li>
                <Link to="/user-accounts" className="text-sm text-gray-600 hover:text-primary-600">
                  User Assignments
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-500">
              © {currentYear} Monness, Crespi, Hardt & Co., Inc. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <span
                className="text-xs text-gray-400 cursor-help"
                title={`Build: ${APP_SHA}\nBranch: ${APP_BRANCH}\nBuilt: ${APP_BUILT_AT}`}
              >
                MCH Commission System &middot; v{APP_VERSION}
              </span>
              <div className="flex items-center text-xs text-gray-400">
                <span>Built with</span>
                <ExternalLink className="h-3 w-3 mx-1" />
                <span>React & TypeScript</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};